/**
 * Create Product Groups context for custom hook
 */
import { createContext } from 'react'

const ProductGroupsContext = createContext({
  fetchProductGroup: () => {},
  fetchProductGroupByCode: () => {},
  fetchProductGroupLineByCode: () => {},
  fetchProductGroupLine: () => {}
})

export default ProductGroupsContext
